import { useEffect, useState } from "react";
import { copyTextToClipboard } from "@/lib/clipboard/copyTextToClipboard";
import { cn } from "@/utils/cn";

export type ClickCopyTextVariant = "name" | "meta" | "email";

interface ClickCopyTextCellProps {
  value: string | null | undefined;
  resourceLabel: string;
  variant?: ClickCopyTextVariant;
  tabularNums?: boolean;
}

export function ClickCopyTextCell({
  value,
  resourceLabel,
  variant = "meta",
  tabularNums = false,
}: ClickCopyTextCellProps) {
  const [copied, setCopied] = useState(false);
  const trimmed = value?.trim();

  useEffect(() => {
    if (!copied) return;
    const t = window.setTimeout(() => setCopied(false), 2000);
    return () => window.clearTimeout(t);
  }, [copied]);

  if (!trimmed) {
    return <span className="cell-meta">{"\u2014"}</span>;
  }

  const onCopy = async () => {
    const ok = await copyTextToClipboard(trimmed);
    if (ok) setCopied(true);
  };

  return (
    <button
      type="button"
      className={cn(
        "click-copy-text block truncate",
        variant === "name" && "click-copy-text--name cell-name",
        variant === "meta" && "click-copy-text--meta cell-meta",
        variant === "email" && "click-copy-text--email",
        tabularNums && "tabular-nums",
        copied && "is-copied",
      )}
      title={copied ? "Copied!" : `Click to copy: ${trimmed}`}
      aria-label={
        copied ? `${resourceLabel} copied` : `Copy ${resourceLabel} ${trimmed}`
      }
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => void onCopy()}
    >
      {copied ? "Copied!" : trimmed}
    </button>
  );
}
